export default {
  approvalDetails: null
};
